document.addEventListener('DOMContentLoaded', function() {
  initializeCompanyEmailFiltering();
});

document.addEventListener('turbolinks:load', function() {
  initializeCompanyEmailFiltering();
});

window.initializeCompanyEmailFiltering = function() {
  let companySelects = document.querySelectorAll('select[id*="responsible_company"]:not([id*="email"])');
  
  if (companySelects.length === 0) {
    companySelects = document.querySelectorAll('select[id$="_responsible_company"]');
  }
  
  companySelects.forEach(function(companySelect) {
    if (companySelect.dataset.filterInitialized) return;
    companySelect.dataset.filterInitialized = 'true';
    
    const emailInput = findCorrespondingEmailInput(companySelect);
    if (!emailInput) return;
    
    const datalistId = emailInput.getAttribute('list');
    if (!datalistId) return;
    
    const datalist = document.getElementById(datalistId);
    if (!datalist) return;
    
    let companyEmailMappings = {};
    const container = companySelect.closest('[data-company-email-mappings]') || 
                      companySelect.closest('form[data-company-email-mappings]');
    
    if (container) {
      const mappingsAttr = container.getAttribute('data-company-email-mappings');
      if (mappingsAttr) {
        try {
          companyEmailMappings = JSON.parse(mappingsAttr);
        } catch (e) {
          console.error('Error parsing company email mappings:', e);
        }
      }
    }
    
    if (!datalist.dataset.originalOptions) {
      const allEmails = Array.from(datalist.querySelectorAll('option')).map(opt => opt.value);
      datalist.dataset.originalOptions = JSON.stringify(allEmails);
    }
    
    companySelect.addEventListener('change', function() {
      filterEmailOptions(this, datalist, companyEmailMappings);
    });
    
    if (companySelect.value) {
      filterEmailOptions(companySelect, datalist, companyEmailMappings);
    }
  });
}

function findCorrespondingEmailInput(companySelect) {
  // Get the base ID of the company select
  const companyId = companySelect.id;
  
  // Try to construct the email input ID
  const emailId = companyId.replace('responsible_company', 'responsible_company_email');
  let emailInput = document.getElementById(emailId);
  
  if (emailInput) return emailInput;
  
  // Fallback: search in the same container
  const container = companySelect.closest('.nested-fields, .action-item, form');
  if (container) {
    emailInput = container.querySelector('input[id*="responsible_company_email"]');
    if (emailInput) return emailInput;
  }
  
  // Last resort: find the next email input after this select
  const allEmailInputs = document.querySelectorAll('input[id*="responsible_company_email"]');
  const companySelects = Array.from(document.querySelectorAll('select[id*="responsible_company"]:not([id*="email"])'));
  const companyIndex = companySelects.indexOf(companySelect);
  
  if (companyIndex >= 0 && companyIndex < allEmailInputs.length) {
    return allEmailInputs[companyIndex];
  }
  
  return null;
}

function filterEmailOptions(companySelect, datalist, companyEmailMappings) {
  const selectedCompany = companySelect.value;
  const originalEmails = JSON.parse(datalist.dataset.originalOptions || '[]');
  
  datalist.innerHTML = '';
  
  let emailsToShow = [];
  
  if (selectedCompany && companyEmailMappings[selectedCompany]) {
    emailsToShow = companyEmailMappings[selectedCompany];
  } else {
    emailsToShow = originalEmails;
  }
  
  emailsToShow.forEach(function(email) {
    const option = document.createElement('option');
    option.value = email;
    datalist.appendChild(option);
  });
}
